import * as actionTypes from '../types/incoming';

const initialState = {
  listIncoming: [],
  listIncomingAreas: [],
  listIncomingBoxes: [],
  listIncomingStocks: [],
  okList: false,
  error: false,
  loading: false,
  loadingData: false,
  okRequest: false,
  okUpdate: false,
  okIncomingAccept: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_INCOMING_UPDATE:
      return {
        ...state,
        okUpdate: true
      };

    case actionTypes.GET_INCOMING:
      return {
        ...state,
        okList: false,
        okRequest: false,
        loading: false,
        error: false,
        loadingData: true,
        okUpdate: false
      };

    case actionTypes.GET_INCOMING_SUCCESS:
      return {
        ...state,
        okList: true,
        loadingData: false,
        okRequest: false,
        listIncoming: payload
      };

    case actionTypes.GET_INCOMING_FAIL:
      return {
        ...state,
        okList: false,
        loadingData: false
      };

    case actionTypes.GET_INCOMING_ACCEPT:
      return {
        ...state,
        okRequest: false,
        okIncomingAccept: false,
        loading: true,
        error: false
      };

    case actionTypes.GET_INCOMING_ACCEPT_SUCCESS:
      return {
        ...state,
        okIncomingAccept: true,
        loading: false,
        okRequest: true
      };

    case actionTypes.GET_INCOMING_ACCEPT_FAIL:
      return {
        ...state,
        okIncomingAccept: false,
        loading: false,
        error: payload
      };

    case actionTypes.GET_INCOMING_REJECT:
      return {
        ...state,
        okRequest: false,
        loading: true,
        error: false
      };

    case actionTypes.GET_INCOMING_REJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        okRequest: true
      };

    case actionTypes.GET_INCOMING_REJECT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.GET_INCOMING_LIST_AREAS:
      return {
        ...state,
        error: false
      };

    case actionTypes.GET_INCOMING_LIST_AREAS_SUCCESS:
      return {
        ...state,
        listIncomingAreas: payload,
        listIncomingBoxes: []
      };

    case actionTypes.GET_INCOMING_LIST_AREAS_FAIL:
      return { ...state };

    case actionTypes.GET_INCOMING_LIST_BOXES:
      return { ...state };

    case actionTypes.GET_INCOMING_LIST_BOXES_SUCCESS:
      return {
        ...state,
        listIncomingBoxes: payload
      };

    case actionTypes.GET_INCOMING_LIST_BOXES_FAIL:
      return { ...state };

    case actionTypes.GET_INCOMING_LIST_STOCKS:
      return { ...state };

    case actionTypes.GET_INCOMING_LIST_STOCKS_SUCCESS:
      return {
        ...state,
        listIncomingStocks: payload,
        listIncomingAreas: [],
        listIncomingBoxes: []
      };

    case actionTypes.GET_INCOMING_LIST_STOCKS_FAIL:
      return { ...state };

    case actionTypes.GET_INCOMING_ERROR_FALSE:
      return {
        ...state,
        error: false
      };

    case actionTypes.GET_INCOMING_CLEAR:
      return {
        ...state,
        okRequest: false
      };

    case actionTypes.SET_INITIAL_STATE_INCOMING:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default reducer;
